import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Target, Heart } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { aboutContent, companyInfo } from '../mock';

export const About = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Nước khoáng i-on kiềm | Thương hiệu</title>
        <meta
          name="description"
          content="Tìm hiểu về sứ mệnh, tầm nhìn và cam kết chất lượng của thương hiệu nước khoáng i-on kiềm O2 cùng quy trình sản xuất an toàn."
        />
        <link rel="canonical" href="https://ionkiemo2.vn/about" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 bg-gradient-to-b from-cyan-50 via-sky-50 to-white 3xl:pt-40 3xl:pb-24 3xl:px-8 4xl:pt-48 4xl:pb-32 4xl:px-12">
        <div className="container mx-auto text-center max-w-screen-4xl 3xl:px-12 4xl:px-16">
          <h1 className="text-5xl font-bold text-slate-900 mb-6 3xl:text-6xl 4xl:text-7xl">Về chúng tôi</h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed 3xl:text-2xl 4xl:text-[28px]">
            Chúng tôi tự hào là đơn vị tiên phong trong lĩnh vực cung cấp nước uống i-on kiềm chất lượng cao tại Việt Nam
          </p>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="py-16 px-4 bg-gradient-to-b from-white via-white to-slate-50 3xl:py-24 3xl:px-8 4xl:py-28 4xl:px-12">
        <div className="container mx-auto max-w-screen-4xl 3xl:px-12 4xl:px-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center 3xl:gap-20">
            <div className="space-y-6">
              <h2 className="text-4xl font-bold text-slate-900 3xl:text-5xl 4xl:text-6xl">
                Cam kết mang đến sức khỏe tốt nhất
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed 3xl:text-xl 4xl:text-2xl">
                Với nhiều năm kinh nghiệm trong ngành nước uống, chúng tôi đã và đang cung cấp hàng triệu chai nước sạch cho các gia đình, doanh nghiệp và tổ chức trên toàn quốc.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed 3xl:text-xl 4xl:text-2xl">
                Sản phẩm của chúng tôi không chỉ đơn thuần là nước uống, mà còn là nguồn nước giàu i-on kiềm tự nhiên, giúp cân bằng độ pH trong cơ thể và mang lại nhiều lợi ích cho sức khỏe.
              </p>
            </div>
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-3xl blur-3xl opacity-20"></div>
              <img 
                src={companyInfo.productImage} 
                alt="Sản phẩm" 
                className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl rounded-2xl 3xl:max-w-xl 4xl:max-w-2xl"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
